import { Form } from "antd";
import { useState } from "react";
import { requetsAssetsSimulation, requetsDeleteAssetsSimulation } from "../../../../redux/slices/simulation/simulationAction";
import { setSelectId, setSelectTypeForm } from "../../../../redux/slices/simulation/simulation";
import { columnsAssestSimulation } from "../../../../types/columnsTables/columnAssetsSimulation";
import { typeForm } from "../../../../types/forms";

export const useColumnsAssetsSimulation = (dispatch, updateProject) => {
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState("");
    const onEditForm = async (id) => {
        try {
            const row = await form.validateFields();
            setEditingKey("");
            dispatch(
                requetsAssetsSimulation({
                    name: row.name,
                    price: row.price,
                    currency: row.currency,
                    link: row.link,
                    status: row.status,
                    area: row.area,
                }, updateProject)
            );
        } catch (error) {
            console.error(error);
        }
    };
    const onDeleteForm = (form) => {
        dispatch(requetsDeleteAssetsSimulation(form.key, updateProject));
    };
    const isEditing = (record) => record.key === editingKey;
    const edit = (record) => {
        form.setFieldsValue({
            name: record.name,
            price: record.price,
            currency: record.currency,
            link: record.link,
            status: record.status,
            area: record.area,
        });
        setEditingKey(record.key);
        dispatch(setSelectTypeForm(typeForm.edit));
        dispatch(setSelectId(record.key));
    };

    const cancelSave = () => {
        setEditingKey("");
    };

    const { columns, props } = columnsAssestSimulation(edit, onDeleteForm, isEditing, editingKey, cancelSave, onEditForm);
    return { columns, props, formAssets: form };
};
